import { configuration } from '../configuration';

export interface AttributesValues {
  [attribute: string]: string[];
}

const TENANT = 'vistaprint';

export async function getAttributeValues(): Promise<AttributesValues | null> {
  const url = `${configuration.urls.discoveryPagesService}/v1/attributesWithValues/${TENANT}?requestor=${configuration.requestor}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    return (await response.json()) as AttributesValues;
  } catch (error) {
    console.log('Error retrieving attribute values', error);
    return null;
  }
}
